<template>
  <div class="content" style="overflow:auto;height:100%;">
    <!-- <el-breadcrumb separator="/">
      <el-breadcrumb-item class="buildItem">项目管理</el-breadcrumb-item>
      <el-breadcrumb-item>
        <a to="/build">质量监控</a>
      </el-breadcrumb-item>
    </el-breadcrumb>-->
    <div class="build-CURD">
      <div class="build-table ceshi">
        <el-table
          class="ceshi"
          :data="tableData"
          style="width: 100%;"
          height="100%"
          stripe
        >
          <template slot="empty">
            <p>{{dataText}}</p>
          </template>
          <!-- <el-table-column label="序号">
            <template slot-scope="scope">
              <span>{{ scope.row.index }}</span>
            </template>
          </el-table-column>-->
          <el-table-column label="检查项目">
            <template slot-scope="scope">
              <span>{{scope.row.projectName}}</span>
            </template>
          </el-table-column>
          <el-table-column label="责任单位">
            <template slot-scope="scope">
              <span>{{ scope.row.dutyUnit }}</span>
            </template>
          </el-table-column>
          <el-table-column label="检查事项">
            <template slot-scope="scope">
              <span>{{ scope.row.checkItem }}</span>
            </template>
          </el-table-column>
          <el-table-column label="检查时间">
            <template slot-scope="scope">
              <span>{{ scope.row.checkTime}}</span>
            </template>
          </el-table-column>
          <el-table-column label="检查人">
            <template slot-scope="scope">
              <span>{{ scope.row.checkPerson}}</span>
            </template>
          </el-table-column>
          <el-table-column label="检查结果">
            <!-- 1.立即暂停 2.组织整改 -->
            <template slot-scope="scope">
              <el-button size="mini" v-if="scope.row.checkResult==1" type="danger">立即暂停</el-button>
              <el-button size="mini" v-if="scope.row.checkResult==2" type="warning">组织整改</el-button>
              <!-- <el-button size="mini" type="primary" @click="handleEdit(scope.$index, scope.row)">查看</el-button> -->
            </template>
          </el-table-column>

          <!-- 编辑窗口 -->
          <!-- <el-dialog
            title="编辑"
            :visible.sync="editFormVisible"
            center
            :append-to-body="true"
            :before-close="handleClose"
            :lock-scroll="false"
            width="30%"
          >
            <el-form :model="editForm" ref="editForm">
              <el-form-item label="名称：">
                <el-input v-model="editForm.name" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="楼号：">
                <el-input v-model="editForm.type" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="类型：">
                <el-input v-model="editForm.adddress" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="所属：">
                <el-input v-model="editForm.people" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="人数：">
                <el-input v-model="editForm.contract" autocomplete="off"></el-input>
              </el-form-item>
            </el-form>
          </el-dialog>-->
        </el-table>
      </div>
      <!-- 分页展示 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[3, 5, 10,20]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalItems"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import myHttp from '../../untils/port'
import util from '../../untils/util.js'
import base from '../../untils/base'
export default {
  data() {
    return {
      tableData: [], //获取数据
      currentPage: 1,
      pageSize: 10,
      totalItems: 0,
      projectId: '',
      dataText: '数据加载中...',
      tabTitle: '',
      num: {
        cjCount: 0,
        glCount: 0,
        grCount: 0,
        tzCount: 0
      },
      loginPlatform: '3'
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    handleSizeChange(val) {
      this.pageSize = val
      this.handleCurrentChange(this.currentPage)
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.currentChangePage()
    },
    // 监控当前页码
    currentChangePage(list) {
      this.getData()
    },
    //表头行样式
    tableHead({ row, rowIndex }) {
      return 'table-head'
    },
    //表头空格样式
    tableHeadCell({ row, rowIndex }) {
      return 'table-head-cell'
    },
    openDetails() {
      console.log(111)
      // util.session.set('proId', row.id)
      this.$router.push({ name: 'redDute' })
    },
    getData() {
      var that = this
      myHttp
        .findQsRedManagerList({
          loginPlatform: this.loginPlatform,
          pageNum: this.currentPage,
          pageSize: this.pageSize
        })
        .then(
          function(resp) {
            if (resp.data.code == '200') {
              var list = resp.data.data.pageInfo.list
              for (var i = 0; i < list.length; i++) {
                list[i].index =
                  that.pageSize * (parseInt(that.currentPage) - 1) + (i + 1)
              }
              that.totalItems = resp.data.data.pageInfo.total
              that.tableData = list
              // var list = resp.data.data.towerWarningInfo || []
              // that.tableData = list
              if (!list || list.length == 0) {
                that.dataText = '暂无数据'
              }
            } else {
              that.$message.error(resp.data.msg)
            }
          },
          function() {}
        )
    }
  }
}
</script>
<style scoped>
.build-bar span {
  margin-left: 10px;
  /* margin-right: 40px */
  font-size: 18px;
  position: relative;
}
* {
  box-sizing: border-box;
}
.content {
  height: 100%;
  /* background: #010d27; */
  /* margin-top: 20px; */
}
.build-CURD {
  width: 100%;
  height: 100%;
  position: relative;
  /* background: #010d27; */
  overflow: hidden;
}
.build-table {
  /* height: calc(100% - 160px);
   */
  height: calc(100% - 68px);
  /* background: #010d27; */
}
.el-table >>> .cell {
  overflow: hidden;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
}
/* .el-table th,
.el-table tr {
  background-color: #000;
} */
.build-bar >>> .btnLef {
  margin-left: 200px;
}

.el-form >>> .upload-demo {
  width: 220px;
  margin-bottom: 20px;
  margin-left: 100px;
}

.add-form >>> .el-upload-dragger {
  width: 100%;
  height: 100px;
}

.build-bar .add-user >>> span {
  text-align: center;
  margin-left: 2px;
}

.add-form .el-form-item {
  width: 80%;
}

.el-dropdown-link {
  cursor: pointer;
  color: #666;
}
.el-icon-arrow-down {
  font-size: 12px;
}
.role-tree {
  overflow-y: scroll;
  min-height: 200px;
}
.build-table {
  position: relative;
  width: 100%;
  margin: 0 auto;
  /* height: calc(100% - 150px); */
}
.build-bar {
  padding: 10px 20px;
  text-align: left;
}
.hand {
  cursor: pointer;
}
img {
  margin-left: 60px;
}
.table-head {
  background: #17b2fe;
}
.table-head-cell {
  background: #17b2fe;
  color: #fff;
}

.el-table--enable-row-hover .el-table__body tr > td {
  background-color: #212e3e !important;
}
/* .ceshi >>> .el-table td,
.ceshi >>> .el-table th.is-leaf {
  border-bottom: 10px solid #010d27;
}
.ceshi >>> .el-table th.is-leaf {
  border-bottom: 10px solid #010d27;
} */
.ceshi >>> .el-table:before {
  left: 0;
  bottom: 0;
  width: 100%;
  height: 0px;
}
.ceshi >>> .el-button {
  cursor: text;
}
/* .el-table__body-wrapper {
  overflow: auto;
  height: calc(100% - 50px);
  position: relative;
} */
</style>
<style>
.head-type span {
  margin-left: 0 !important;
}
.el-menu.el-menu--horizontal {
  box-shadow: none;
}
/* .el-table td{
    border-bottom: 1px solid #010D27;
} */
</style>
<style>
</style>